import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=54c1af8c&scoped=true"
import script from "./Warehouse.vue?vue&type=script&lang=js"
export * from "./Warehouse.vue?vue&type=script&lang=js"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=54c1af8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1af8c",
  null
  
)

export default component.exports